/** @format */

export default function urlSanitizer(str: string) {
  return str.replace(/\s+/g, '-').replace(/\?/g, '').replace(/,/g, '').toLowerCase();
}
